document.addEventListener("DOMContentLoaded", function() {
    const imageContainer = document.querySelector('[data-image-container]');
    let isImageContainerContainerActive = false;

    function setupCard(card) {
        const resultCardImage = card.querySelector('template[data-card-image]');

        card.addEventListener('mouseover', function() {
            if (card.dataset.resultCardActive === 'false' && resultCardImage) {

                // fade original image container in on first run
                if (isImageContainerContainerActive === false) {
                    imageContainer.dataset.active = 'true';
                    isImageContainerContainerActive = true;
                }

                // selects all new images that have been added
                const existingNewImages = imageContainer.querySelectorAll('[data-image-active]');

                // Set all cards' active state to false
                document.querySelectorAll('[data-result-card-active]').forEach(card => {
                    card.dataset.resultCardActive = 'false';
                });

                // Set current card to active
                card.dataset.resultCardActive = 'true';

                // Create new image based on template image
                const imageHtml = resultCardImage.innerHTML;
                const newImage = document.createElement('div');
                newImage.classList.add('group/card-image');
                newImage.innerHTML = imageHtml;
                setTimeout(function() {
                    newImage.setAttribute('data-image-active', 'true');
                }, 50);

                // Append new image to the image container
                imageContainer.appendChild(newImage);

                // Clean up / remove images when no longer required
                existingNewImages.forEach(image => {
                    image.dataset.imageActive = 'false';
                    image.addEventListener('transitionend', function() {
                        if (imageContainer.contains(image)) {
                            imageContainer.removeChild(image);
                        }
                    });
                });
            }

            const removeOnHover = document.querySelector('.remove-on-hover');
            if (removeOnHover) {
                setTimeout(function() {
                    removeOnHover.style.opacity = 0;
                }, 150);
                setTimeout(function() {
                    removeOnHover.remove();
                }, 650);
            }
        });
    }

    function setupDynamicResults() {
        // check if results card container exists before running
        const resultsContainer = document.querySelector('.dynamic-card-results');

        if (resultsContainer) {
            resultsContainer.addEventListener('mouseover', function(event) {
                const card = event.target.closest('[data-result-card-active]');
                if (card) {
                    setupCard(card);
                }
            });
        }
    }

    setupDynamicResults();
});
